module.exports = __webpack_public_path__ + "img/album12_03.4c9fa4d5.jpg";